<template>
  <a href="#"
    class="inline-block"
    :aria-label="newWindowLabel"
  >
    <img v-show="thumbnail && !error"
      :src="thumbnailVersion"
      :height="height ? height : ''"
      :width="width ? width : ''"
      :alt="LANG.preview"
      style="aspect-ratio: 4 / 3"
      @error="fallbackImage"
      @load="imgLoaded"
    />
    <DocumentFiletypeIcon v-show="!thumbnail || error"
      :mimeType="mimeType"
      :height="height ? height : ''"
      :width="width ? width : ''"
    />
  </a>
</template>

<script>
import { mapState } from 'vuex';
import { defineComponent } from 'vue';
import DocumentFiletypeIcon from '@/components/browser/documents/DocumentFiletypeIcon.vue';

export default defineComponent({
  components: {
    DocumentFiletypeIcon,
  },
  props: {
    mimeType: {
      type: String,
    },
    thumbnail: {
      type: String,
    },
    version: {
      type: String,
    },
    width: {
      type: Number,
      default: 66,
    },
    height: {
      type: Number,
      default: 44,
    },
  },
  data: () => ({
    error: false,
  }),
  methods: {
    fallbackImage() {
      this.error = true;
    },
    imgLoaded() {
      this.error = false;
    },
  },
  computed: {
    ...mapState(['LANG']),
    newWindowLabel() {
      return `${this.LANG.preview} ${this.LANG.opensBlank}`;
    },
    thumbnailVersion() {
      return this.version ? `${this.thumbnail}?v=${this.version}` : this.thumbnail;
    },
  },
});
</script>
